<template>
  <v-footer color="black" dark>
    <v-card-text class="black dark text-center white--text">
      @2000-{{ new Date().getFullYear() }} Impresa Edile Baldassarri C. & Pace G. S.r.l. Tutti i diritti riservati - P.I. 01197060435
    </v-card-text>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer',
    data: () => ({
      
    }),
  }
</script>

<style>
</style>